import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Output,
    EventEmitter,
} from '@angular/core';

@Component({
    selector: 'app-kyc-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['./otp.component.scss'],
})
export class OtpComponent implements OnInit {
    @Output() otpComplete = new EventEmitter<{}>();
    @ViewChild('otp0', { static: false }) otp0: ElementRef;
    @ViewChild('otp1', { static: false }) otp1: ElementRef;
    @ViewChild('otp2', { static: false }) otp2: ElementRef;
    @ViewChild('otp3', { static: false }) otp3: ElementRef;
    @ViewChild('otp4', { static: false }) otp4: ElementRef;
    @ViewChild('otp5', { static: false }) otp5: ElementRef;
    otpArray: string[] = [];

    otpInput(e, index) {
        const value = e.target.value;
        if (value.length !== 1) {
            this.otpComplete.emit(false);
            this.otpArray[index] = null;
            return;
        }
        if (index === 5 && this.otpArray[5]) {
            return;
        }
        this.otpArray[index] = value;
        if (this.isOtpComplete()) {
            this.otpComplete.emit({
                otp: this.otpArray.join(''),
            });
            return;
        }
        if (index === 0) {
            this.otp1.nativeElement.readOnly = false;
            this.otp1.nativeElement.focus();
            this.otpArray[index + 1] = null;
        } else if (index === 1) {
            this.otp2.nativeElement.readOnly = false;
            this.otp2.nativeElement.focus();
            this.otpArray[index + 1] = null;
        } else if (index === 2) {
            this.otp3.nativeElement.readOnly = false;
            this.otp3.nativeElement.focus();
            this.otpArray[index + 1] = null;
        }else if (index === 3) {
            this.otp4.nativeElement.readOnly = false;
            this.otp4.nativeElement.focus();
            this.otpArray[index + 1] = null;
        }else if (index === 4) {
            this.otp5.nativeElement.readOnly = false;
            this.otp5.nativeElement.focus();
            this.otpArray[index + 1] = null;
        }
         else {
            this.otp5.nativeElement.blur();
        }
    }

    isOtpComplete(): boolean {
        const every = this.otpArray.every((e) => !isNaN(+e));
        return every && this.otpArray.length === 6;
    }

    checkOtpInput() {
        if (!this.otpArray[0]) {
            this.otp0.nativeElement.focus();
            return;
        }
    }

    otpKeyPress(e, index) {
        if (e.code === 'ArrowLeft') {
            if (index === 1) {
                this.otp1.nativeElement.readOnly = true;
                this.otp0.nativeElement.focus();
            } else if (index === 2) {
                this.otp2.nativeElement.readOnly = true;
                this.otp1.nativeElement.focus();
            } else if (index === 3) {
                this.otp3.nativeElement.readOnly = true;
                this.otp2.nativeElement.focus();
            } else if (index === 4) {
                this.otp4.nativeElement.readOnly = true;
                this.otp3.nativeElement.focus();
            } else if (index === 5) {
                this.otp5.nativeElement.readOnly = true;
                this.otp4.nativeElement.focus();
            }

            return;
        }
        if (
            e.code === 'ArrowRight' &&
            (this.otpArray[index + 1] || this.otpArray[index + 1] === null)
        ) {
            if (index === 0) {
                this.otp1.nativeElement.readOnly = false;
                this.otp1.nativeElement.focus();
            } else if (index === 1) {
                this.otp2.nativeElement.readOnly = false;
                this.otp2.nativeElement.focus();
            } else if (index === 2) {
                this.otp3.nativeElement.readOnly = false;
                this.otp3.nativeElement.focus();
            }else if (index === 3) {
                this.otp4.nativeElement.readOnly = false;
                this.otp4.nativeElement.focus();
            }else if (index === 4) {
                this.otp5.nativeElement.readOnly = false;
                this.otp5.nativeElement.focus();
            }
        }
    }

    constructor() {}

    ngOnInit() {}
}
